import React from "react";
import { HeadBandContainer } from "./style";
import { redirectURL } from "../../../../landing/constants/functions";
import { likeDark } from "../../../assets";
import { Button } from "@prima-afp/prima-ui-design-system/dist/ui-components";
import { useHistory } from "react-router-dom";

const Headband = () => {
  const history = useHistory();
  return (
    <HeadBandContainer>
      <div className="container">
        <img src={likeDark} alt="like" />
        <p className="text">
          <span className="bold">
            Cambiarte de AFP es simple: Miles ya lo hicieron 
          </span>{" "}
          (Boletín SBS).
        </p>
        <Button
          label="Cámbiate ya"
          size="small"
          onClick={() => {
            redirectURL(history, "traspaso", {
              event: "menu_click",
              payload: {
                section: "landing traspaso",
                sub_section: "boton - cintillo",
                option: "cambiate ya",
              },
            });
          }}
        />
      </div>

    </HeadBandContainer>
  );
};

export default Headband;
